import { communicationBridge } from '@core/bridge/communicationBridge'
import { CHAT_CONNECTION_ID, TO_CHAT } from '@core/bridge/contracts/chatContract'

// Imperative senders for the chat connection. Kept framework-free so non-React
// code (e.g. the betting orchestrator) can share wins without importing the
// bridge internals. Every call is best-effort: the transport no-ops when chat
// isn't mounted/connected.

const send = (type, payload) => communicationBridge.send(CHAT_CONNECTION_ID, type, payload)

export const ackHandshake = () => send(TO_CHAT.HANDSHAKE_ACK, {})

export const sendDisplayMode = (display = {}) => send(TO_CHAT.DISPLAY_MODE, display)

/**
 * Share a cashout win into the chat. Amounts MUST be numbers — the chat app
 * rejects string amounts.
 */
export const shareWin = ({ gameName, cashoutMultiplier, cashoutAmount, betAmount } = {}) => {
  const num = (value) => Number(value) || 0
  return send(TO_CHAT.SHARE_WIN, {
    gameName: gameName ?? '',
    cashoutMultiplier: num(cashoutMultiplier),
    cashoutAmount: num(cashoutAmount),
    betAmount: num(betAmount),
  })
}
